// extracted by mini-css-extract-plugin
export default {"all_products":"allproducts_all_products__YsiX8","left":"allproducts_left__I+Ee+","right":"allproducts_right__jAXfo"};